import { FilterHandler } from '@btime/react-contexts'
import React from 'react'

import ChecklistsLoader from './_load/ChecklistsLoader'
import ControlledModal from '../../../components/modals/ControlledModal'
import LineSeparator from '../../../packages/kiti/components/helpers/LineSeparator'
import ModalHeader from './ModalHeader'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import TemplatesList from './TemplatesList'
import SearchBar from './SearchBar'

const ListTemplateChecklistModal = props => {
  return (
    <ControlledModal width="64rem" fullScreen {...props}>
      <FilterHandler>
        <ModalHeader />
        <LineSeparator weight={2} />
        <SearchBar />
        <Separator weight={6} />
        <ChecklistsLoader>
          <TemplatesList />
        </ChecklistsLoader>
      </FilterHandler>
    </ControlledModal>
  )
}

export default ListTemplateChecklistModal
